// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { PillLabel } from '../misc';
import FlaggableInstrument from '@/types/flaggable-instrument';
import { formatMessage } from '@/utils/i18n';
import { PortfolioFlag } from '@/utils/constants';

type Props = {
  flaggableInstrument: FlaggableInstrument;
  className?: string;
};

const CustomTypePills = ({ flaggableInstrument, className }: Props) => {
  const { flags } = flaggableInstrument;

  if (flags == null) {
    return null;
  }

  const localFlags = flags.reduce((acc, status) => {
    if (status === PortfolioFlag.AcceptedPortfolio) {
      acc.push(formatMessage('PortfoliosTable.Pills.Accepted'));
    }

    if (status === PortfolioFlag.UnallocatedPortfolio) {
      acc.push(formatMessage('PortfoliosTable.Pills.Draft'));
    }

    const parts = status.split('-');
    if (parts.length === 2 && parts[0] === 'customType') {
      acc.push(parts[1]);
    }
    return acc;
  }, [] as Array<string>);

  return (
    <>
      {localFlags.map((flag, index) => (
        <PillLabel key={index} className={classNames('outline', className)} text={flag} />
      ))}
    </>
  );
};

export default CustomTypePills;
